import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
import { Delete } from './delete';
import { Edit } from './edit';
import { DropdownHeader } from './header';
import { Link } from './link';
const StyledMenu = styled(AntMenu)`
  width: 240px;
  padding: var(--spacing-02) var(--spacing-02);
  max-height: 70vh;
  overflow: auto;

  .ant-dropdown-menu-item-group-list {
    margin: 0;
  }
  .ant-dropdown-menu-item {
    line-height: var(--line-height-code-01);
  }
  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    display: flex;
    align-items: center;
    padding: var(--spacing-03) var(--spacing-04);
    border-radius: var(--border-radius-small);
    line-height: var(--line-height-code-01);
    .ant-dropdown-menu-submenu-expand-icon {
      right: 1rem;
    }
  }
  .ant-dropdown-menu-item.ant-dropdown-menu-item-danger.ant-dropdown-menu-item-disabled {
    color: var(--gray-40);
    &:hover {
      background-color: var(--white-100);
    }
  }

  .ant-dropdown-menu-item .ant-menu-item-icon,
  .ant-dropdown-menu-item .ant-dropdown-menu-item-icon,
  .ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-vertical
    > .ant-dropdown-menu-submenu-title
    > svg {
    margin-right: var(--spacing-03);
  }

  .ant-dropdown-menu-item-divider {
    margin: 4px;
    background-color: #f2f2f2;
  }
`;
const Menu = StyledMenu;
const ItemWithPermission = withHideIfNotAllowed(AntMenu.Item);
Menu.Header = DropdownHeader;
Menu.ItemDelete = Delete;
Menu.ItemEdit = Edit;
Menu.Link = Link;
Menu.ItemWithPermission = ItemWithPermission;
export { Menu };
